import { Features } from '../features';
import { useFeatureTreatment } from './use-feature-treatment';

export const usePortfoliosFeature = () => useFeatureTreatment(Features.portfolios);
export const useSplitFlagsFeature = () => useFeatureTreatment(Features.splitFlags);
export const useEntitiesFeature = () => useFeatureTreatment(Features.entities);
export const useDatadogRumSessionReplayFeature = () => useFeatureTreatment(Features.datadogRum);
export const usePortfolioSetupOldFeature = () => useFeatureTreatment(Features.portfolioSetupOld);
